export default {
  SET_PAYMENT_STATUSES (state, payment_statuses) {
    state.payment_statuses = payment_statuses
  },
  REMOVE_RECORD (state, itemId) {
    const paymentStatusIndex = state.payment_statuses.findIndex((u) => u.id === itemId)
    state.payment_statuses.splice(paymentStatusIndex, 1)
  }
}
